<div class="bond-container">
	<div>
		@if (selectedCi?.relationships?.parents && selectedCi.relationships.parents.length > 0) {
			<div>
				{{ labels.lbl_responsaveis_ci }}
				@for (parents of selectedCi.relationships.parents; let index = $index; track parents) {
					<a [routerLink]="'/cmdb/ci/' + selectedCi.relationships.parents[0].id_related">
						<span>
							<span class="link">"{{ parents.name }}"</span>
							@if (index !== selectedCi.relationships.parents.length - 1) {
								<span>
									{{ index === selectedCi.relationships.parents.length - 2 ? ' ' + this.labels.lbl_geral_e + ' ' : ', ' }}
								</span>
							}
						</span>
					</a>
				}
			</div>
		}

		@if (selectedCi?.relationships?.parents && selectedCi.relationships.parents.length === 0) {
			<div>{{ labels.lbl_este_ci_independente }}</div>
		}
	</div>

	<div>
		@if (selectedCi?.relationships?.childs && selectedCi.relationships.childs.length > 0) {
			<div>
				{{ labels.lbl_dependente_ci }}
				@for (child of selectedCi.relationships.childs; let index = $index; track child) {
					<a [routerLink]="'/cmdb/ci/' + child.id_related">
						<span>
							<span class="link">"{{ child.name }}"</span>
							@if (index !== selectedCi.relationships.childs.length - 1) {
								<span>
									{{ index === selectedCi.relationships.childs.length - 2 ? ' ' + this.labels.lbl_geral_e + ' ' : ', ' }}
								</span>
							}
						</span>
					</a>
				}
			</div>
		}

		@if (selectedCi?.relationships?.childs && selectedCi.relationships.childs.length === 0) {
			<div>{{ labels.lbl_e_nao_responsavel }}</div>
		}
	</div>

	@if (this.viewType === 'edit') {
		<div class="new-bond-container">
			<div class="title">{{ labels.lbl_criar_novo_vinculo }}</div>

			<pcp-cmdb-search-gadget [ignoreCiList]="ignoreBondCiArr.join(',')" (getCi)="selectBondCi($event); bondCiModal.openModal()">
			</pcp-cmdb-search-gadget>
		</div>
	}

	@if (
		(selectedCi?.relationships?.parents && selectedCi.relationships.parents.length > 0) ||
		(selectedCi?.relationships?.childs && selectedCi.relationships.childs.length > 0)
	) {
		<div class="new-bond-container">
			<div class="title">{{ labels.lbl_remover_vinculos_existentes }}</div>

			@for (parent of selectedCi.relationships.parents; let indexParent = $index; track parent) {
				<div class="existing-bond">
					<div>
						<span (click)="selectMultipleCI(parent, indexParent)" class="select-bond-remove" [title]="parent.name">
							<fa-icon
								[icon]="
									selectedCi.relationships.parents[indexParent].isChecked === true ? icons.faCheckSquare : icons.faSquare
								"></fa-icon>
							{{ parent.name }}</span
						>
						<span>({{ labels.lbl_geral_responsavel }})</span>
					</div>
					<span
						[title]="labels.lbl_geral_remover"
						(click)="
							confirmUnbondParent.classList.contains('confirmClick') ? unbondCi(parent) : confirmButton(confirmUnbondParent)
						"
						#confirmUnbondParent
						><fa-icon [icon]="icons.faTrash"></fa-icon>
					</span>
				</div>
			}

			@for (child of selectedCi.relationships.childs; let indexChild = $index; track child) {
				<div class="existing-bond">
					<div>
						<span (click)="selectMultipleCI(child, indexChild)" class="select-bond-remove" [title]="child.name">
							<fa-icon
								[icon]="
									selectedCi.relationships.childs[indexChild].isChecked === true ? icons.faCheckSquare : icons.faSquare
								"></fa-icon>
							{{ child.name }}</span
						>
						<span>({{ labels.lbl_geral_dependente }})</span>
					</div>
					<span
						[title]="labels.lbl_geral_remover"
						(click)="
							confirmUnbondChild.classList.contains('confirmClick') ? unbondCi(child) : confirmButton(confirmUnbondChild)
						"
						#confirmUnbondChild
						><fa-icon [icon]="icons.faTrash"></fa-icon>
					</span>
				</div>
			}

			<div class="button-container mt-3">
				<div class="button" (click)="unbondSelectedCi($event)" #unbondSelectedCiButtonn>
					{{
						unbondSelectedCiButtonn.classList.contains('double-click')
							? labels.lbl_geral_confirmar
							: labels.lbl_remover_bond_selecionados
					}}
				</div>
				<div class="button" (click)="unbondAllCi($event)" #unbondAllCiButton>
					{{ unbondAllCiButton.classList.contains('double-click') ? labels.lbl_geral_confirmar : labels.lbl_remover_todos_bond }}
				</div>
			</div>
		</div>
	}
</div>

<cpi-modal [title]="labels['lbl_geral_vincular']" [showFooter]="true" (onModalClose)="selectedBondCi = null" #bondCiModal>
	<ng-container body>
		{{ labels['lbl_geral_vincular'] }} <span class="link">{{ selectedBondCi?.identification }}</span>
		{{ labels['lbl_geral_a_craseado'] }} <span class="link">{{ selectedCi?.identification }}</span>
		{{ labels['lbl_como_contexto_as'] }}:
	</ng-container>

	<ng-container footer>
		<div class="button-container">
			<msp-button (click)="selectedBondCi = null; bondCiModal.closeModal()">{{ labels.lbl_geral_cancelar }}</msp-button>
			<msp-button [disabled]="isAddingBond" [loading]="isAddingBond" (click)="bondCi('Child')">
				{{ labels.lbl_geral_dependente }}
			</msp-button>
			<msp-button [disabled]="isAddingBond" [loading]="isAddingBond" (click)="bondCi('Parent')">
				{{ labels.lbl_geral_responsavel }}
			</msp-button>
		</div>
	</ng-container>
</cpi-modal>
